// ページトップボタン & チャットアプリ（部分更新対応版）
// ------------------------------------------------------
(function () {
    const SCROLL_THRESHOLD = 200;

    function updateButtonVisibility() {
        const pageTopBtn = document.querySelector(".ccm-pageTop-btn");
        const chatApp = document.querySelector("#shopify-chat");
        const footer = document.querySelector(".footer");
        if (!footer) return;

        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const footerRect = footer.getBoundingClientRect();
        const footerBottom = footerRect.bottom;
        const hasReachedFooterLimit = footerBottom <= viewportHeight + 82;

        if (pageTopBtn) {
            if (scrollY <= SCROLL_THRESHOLD) {
                pageTopBtn.style.transitionDelay = "0s";
                pageTopBtn.style.opacity = "0";
            } else if (!hasReachedFooterLimit) {
                pageTopBtn.style.transitionDelay = "0.3s";
                pageTopBtn.style.opacity = "1";
            } else {
                pageTopBtn.style.transitionDelay = "0s";
                pageTopBtn.style.opacity = "0";
            }
        }

        if (chatApp) {
            if (hasReachedFooterLimit) {
                chatApp.style.transitionDelay = "0s";
                chatApp.style.opacity = "0";
            } else {
                chatApp.style.transitionDelay = "0.3s";
                chatApp.style.opacity = "1";
            }
        }
    }

    // ── フルリロード時／初回読み込み時 ──
    document.addEventListener("DOMContentLoaded", () => {
        updateButtonVisibility();
        window.addEventListener("scroll", updateButtonVisibility);
    });

    // ── Turbo Drive / Turbolinks など、ページ部分更新時の再初期化 ──
    document.addEventListener("turbo:load", () => {
        updateButtonVisibility();
        window.addEventListener("scroll", updateButtonVisibility);
    });

    // ── Shopify テーマのセクションエディタなどでキャプチャされる場合 ──
    document.addEventListener("shopify:section:load", () => {
        updateButtonVisibility();
        window.addEventListener("scroll", updateButtonVisibility);
    });
})();


// スクロールフェードインアニメーション（再利用可能）
// ------------------------------------------------------
// 使用方法:
//   コンテナ: data-reveal-container
//   アイテム: data-reveal-item
//
// 例:
//   <div data-reveal-container>
//     <div data-reveal-item>Item 1</div>
//     <div data-reveal-item>Item 2</div>
//   </div>
// ------------------------------------------------------
(function () {
    const STAGGER_DELAY = 0.05; // 各アイテム間の遅延（秒）
    const START_DELAY = 0.4;    // 最初のアイテムの遅延（秒）
    const THRESHOLD = 0.2;      // 画面内に20%入ったらトリガー

    function initRevealAnimation() {
        const containers = document.querySelectorAll('[data-reveal-container]:not([data-reveal-initialized])');

        if (containers.length === 0) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const container = entry.target;
                    const items = container.querySelectorAll('[data-reveal-item]');

                    items.forEach((item, index) => {
                        const delay = START_DELAY + (index * STAGGER_DELAY);
                        item.style.transitionDelay = `${delay}s`;

                        // 少し遅らせてクラスを追加（CSSトランジションを確実に発火させるため）
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                item.classList.add('is-revealed');
                            });
                        });
                    });

                    // 一度表示されたら監視を解除
                    observer.unobserve(container);
                }
            });
        }, {
            threshold: THRESHOLD,
            rootMargin: '0px 0px -50px 0px' // 下から50px手前でトリガー
        });

        containers.forEach((container) => {
            container.setAttribute('data-reveal-initialized', 'true');
            observer.observe(container);
        });
    }

    // ── フルリロード時／初回読み込み時 ──
    document.addEventListener("DOMContentLoaded", initRevealAnimation);

    // ── Turbo Drive / Turbolinks など、ページ部分更新時の再初期化 ──
    document.addEventListener("turbo:load", initRevealAnimation);

    // ── Shopify テーマのセクションエディタなどでキャプチャされる場合 ──
    document.addEventListener("shopify:section:load", initRevealAnimation);
})();
